import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { PaymentCard } from '../../models/payment-card';
import { storeById } from '../../utils/converter';
import {
    getPaymentCardsAsync,
    updatePrimaryCardAsync
} from '../../apis/payment-gateway';

export interface State {
    allIds: string[];
    primaryId: string;
    byId: Dictionary<PaymentCard>;
    loading: Dictionary<boolean>;
}

export const paymentCards = createModel<State>({
    state: {
        allIds: [],
        primaryId: '',
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: PaymentCard[],
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...storeById(data)
            };
            return {
                ...state,
                allIds: Object.keys(byId).sort((a, b) => byId[a]!.last4 > byId[b]!.last4 ? 1 : -1),
                primaryId: Object.keys(byId).find(x => byId[x]!.primary) || '',
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getPaymentCardsAsync(_: Undefinable<{}>, rootState: RootState) {
            if (selectors.getPaymentCardIds(rootState.paymentCards).length === 0 &&
                !selectors.getLoading(rootState.paymentCards, 'getPaymentCardsAsync')
            ) {
                this.loading('getPaymentCardsAsync', true);
                try {
                    const data = await getPaymentCardsAsync();
                    this.update(data, 'getPaymentCardsAsync');
                } catch (e) {
                    window.console.log(e);
                    this.loading('getPaymentCardsAsync', false);
                }
            }
        },
        async updatePrimaryCardAsync(cardId: string) {
            this.loading('updatePrimaryCardAsync', true);
            try {
                const response = await updatePrimaryCardAsync(cardId);
                if (response.success) {
                    this.update(response.data, 'updatePrimaryCardAsync');
                } else {
                    window.console.log(response.message);
                    this.loading('updatePrimaryCardAsync', false);
                }
            } catch (e) {
                window.console.log(e);
                this.loading('updatePrimaryCardAsync', false);
            }
        }
    })
});
